import { BaseModel } from './base-model';
import { VoyageRoutePointFeature } from './voyage-routing-model';

export interface ForecastInfo
{
    name: string;
    timestamp: string;
    forecast_from: string;
    forecast_to: string;
    hasLowResData: boolean;
    hasHighResData: boolean;

    // only present for vessel version
    subscriptions?: {
        id: string;
        import_date: string;
    }[];
}

export type SpotWeatherInfo = VoyageRoutePointFeature;

export interface LocationAndTime
{
    coordinates: [number, number];
    timestamp: string;
}

export abstract class WeatherModelBase extends BaseModel
{
    abstract elements: string[];
    abstract get latestForecastVersion(): string;
    abstract get latestForecastInfo(): ForecastInfo|null;
    abstract get recentForecastVersions(): string[];
    abstract get climaticForecast(): string;
    abstract getSpotWeather(coordinates: [number, number], timestamp: string): Promise<SpotWeatherInfo>;
    abstract getMultiSpotWeather(locationAndTimes: LocationAndTime[]): Promise<SpotWeatherInfo[]>;
    abstract destroy(): void;
    abstract _updateForecasts(startTime: number): void;
}

let WeatherModel:WeatherModelBase|null = null;

function setWeatherModel(model: WeatherModelBase)
{
    WeatherModel = model;
}

export { WeatherModel, setWeatherModel };
